export default __webpack_public_path__ + "static/media/6-0.f09687e4.png";